import React, { useMemo } from 'react';
import { ReportingShellContainerBaseConfig } from '../../../base';
import { ChatErrorContainerProps } from './chatErrorProps';
import { ChatErrorController, ChatErrorLoader } from './chatErrorInterface';
import { ChatContextProvider, ChatDetailContextValue } from '../detail';

export function createChatErrorContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatErrorLoader,
    controller: ChatErrorController
): React.FC<ChatErrorContainerProps> {
    const {
        context: { useContext },

        repository: { platform },
    } = config;

    return config.state.chat.subscribe(({ as: View, ...containerProps }) => {
        const context = useContext();
        const state = {
            chat: config.state.chat.useState(context),
            composer: config.state.composer.useState(context),
        };
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            onClear() {
                console.log('clearing error, resetting thread state');
                state.chat.onChange({
                    thread: null,
                });
            },
        });
        return <View {...props} />;
    });
}
